export const Heading = {
  baseStyle: {
    color: 'gray.700',
    fontFamily: 'heading'
  }
}
